export default __webpack_public_path__ + "media/images/ui-icons_444444_256x240-d1b818587c3bc65058fe43800e4a191c.png";